<script setup lang="ts">
import { computed } from 'vue'
import { useGlobalStore } from '@/stores/global'
import { RouterView } from 'vue-router'

/** Global Store */
const globalStore = useGlobalStore()

const breadcrumbs = computed({
  get: () => globalStore.getBreadcrumbs(),
  set: (v) => globalStore.setBreadcrumbs(v)
})
</script>
<template>
  <v-container>
    <v-row>
      <v-col :cols="12" class="mb-4">
        <v-breadcrumbs
          :items="breadcrumbs"
          divider=">"
          class="pa-2 bg-white rounded"
          v-if="breadcrumbs.length > 0"
        >
          <!--        <template v-slot:item="{ item }">-->
          <!--          <v-breadcrumbs-item :href="item.href" @click="showSelectedRow2(item)">-->
          <!--            {{ item.text }}-->
          <!--          </v-breadcrumbs-item>-->
          <!--        </template>-->
          <!--        <template v-slot:divider>-->
          <!--          <v-icon icon="mdi-chevron-right"></v-icon>-->
          <!--        </template>-->
        </v-breadcrumbs>
        <router-view />
      </v-col>
    </v-row>
  </v-container>
</template>
